import { render, staticRenderFns } from "./GenericMovieList.vue?vue&type=template&id=b3ce3a7a&scoped=true"
import script from "./GenericMovieList.vue?vue&type=script&lang=js"
export * from "./GenericMovieList.vue?vue&type=script&lang=js"
import style0 from "./GenericMovieList.vue?vue&type=style&index=0&id=b3ce3a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ce3a7a",
  null
  
)

export default component.exports